import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export default function RequireAuth({ children }) {
  const location = useLocation();
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
  const rawUser = typeof localStorage !== 'undefined' ? localStorage.getItem('user') : null;

  if (!token || !rawUser) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  try {
    JSON.parse(rawUser);
  } catch {
    return <Navigate to="/" replace />;
  }

  return children;
}

